import { Component } from '@angular/core';

@Component({
  selector: 'kt-med-review',
  templateUrl: './med-review.component.html',
  styleUrls: ['./med-review.component.scss'],
})
export class MedReviewComponent {}
